module.exports = __webpack_public_path__ + "img/iPhone5_sml-bcd98ee0f031d9a11010baaac41cbdaf.png";